__turbopack_context__.v({
  "className": "poppins_af3113d3-module__wautkG__className",
  "variable": "poppins_af3113d3-module__wautkG__variable",
});
